export default {
  menu: {
    projects: "Invest",
    about: "About us",
    user: "User",
    dashboard: "Dashboard",
    dashboard_admin:"Panel",
    login: "Login",
    signup: "Sign Up",
    restore_password: "Restore Password"
  },
  login:{
    email: "Email",
    password: "Password",
    button_start: "Get start",
    button_forgot: "Forgot your password?",
    have_account: "Already have an account?"
  },
  signup: {
    button: "Get Started"
  },
  restore: {
    button: "Restore"
  },
  detail: {
    button_more: "More detail"
  },
  index: {
    title: 'Investment Opportunities',
    subtitle: 'View our current open offerings',
    title_closed: 'Investment closed',
    button_investment: 'to invest'
  },
  profile:{
    title: "Profile",
    password: "Password",
    password_confirm: "Password Confirm",
    button_change: "Change Password",
    title_1: "Change Password",
    title_2: "Digital signature",
    profile: "Profile",
    password: "Password",
    signature: "Signature",
    qualify: "¿Qualify?",
    qualify_yes: "Yes",
    qualify_no: "No",
    button_profile: "Save",
    button_signature: "Generate"
  },
  notifications: {
    title: "Notifications",
    status_news: "News",
    status_readed: "Readed",
    status_archived: "Achived"
  },
  unconfirm: {
    message: "We have sent an email to the registered email. Please confirm your account before starting",
    redirect: "You will be redirected"
  },
  settings: {
    title: "Management Panel",
    projects: "Projects",
    users: "Users",
    roles: "Roles",
    permissions: "Resources of role",
    configs: "Settings",
    button_save: "Save",
    button_cancel: "Cancel"
  },
  projects: {
    name: "Name",
    date_start: "Start",
    date_end: "End",
    summary: "Summary",
    ammount_total: "Ammount",
    ammount_recauded: "Recauded",
    project_type: "Type",
    status: "Status",
    btn_change_stage: "Current stage",
    btn_add_ammount: "Add",
    media_title: "Images",
    info_title:"Project Info",
    media_data_max_size: "jpg/png files smaller than 5 MB",
    ammount_investment: "Ammount investment",
    documents: "Prospect"
  },
  users: {
    name: "Name",
    email: "Email",
    status: "Status",
    origin: "Origin",
    registered_at: "Registered At",
    qualify: "Qualified"
  },
  roles: {
    name: "Name"
  },
  alerts: {
    title: "Alerts",
    date: "Date",
    subject: "Subject"
  },
  investment: {
    title: "My Inverstments",
    registered_at: "Registered At",
    ammount_investment: "Ammount",
    ammount_recauded: "Recauded",
    confirmed_at: "Confirmet At",
    project_name: "Project",
    status: "Status",
    reference_payment: "Reference"
  },
  portfolio: {
    title: "My Portfolio",
    registered_at: "Registered At",
    ammount_investment: "Ammount",
    ammount_recauded: "Recauded",
    confirmed_at: "Confirmet At",
    project_name: "Project"
  },
  configurations: {
    name: "Name"
  },
  helpcenter:{
    title: "Help Center"
  }
}
